require("!!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\script-loader\\addScript.js")(require("!!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\raw-loader\\index.js!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\ng2-toastr\\bundles\\ng2-toastr.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/ng2-toastr/bundles/ng2-toastr.min.js
// module id = 755
// module chunks = 322